<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <!-- <button
          class="btn btn-download btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#downloadPackageModal"
          :disabled="buttonDisabled"
          @click="downloadPackage"
        >
          Download Selected Packages
        </button> -->
        <button
          class="btn btn-download btn-success"
          data-bs-toggle="modal"
          data-bs-target="#requestScuModal"
          @click=""
        >
          System Configure Request
        </button>
      </div>
    </div>
    <div class="row">
      <vue-good-table
        class="vue-table"
        ref="table"
        :columns="columns"
        :rows="typesenseStore.packageList"
        styleClass="vgt-table condensed bordered"
        @row-click="typesenseStore.fetchCurrent"
        @page-change="onPageChange"
        @sort-change="onSortChange"
        @per-page-change="onPerPageChange"
        :isLoading.sync="isLoading"
        :pagination-options="paginationOptions"
        :totalRows="typesenseStore.totalRecords"
        ><template #table-actions-bottom>
          <pagination-records
            :pages="serverParams.page"
            :per-page="serverParams.per_page"
            :total="typesenseStore.totalRecords"
        /></template>
        <template #table-row="props">
          <!-- <span v-if="props.column.field == 'checkbox'">
            <span v-if="props.row.checkboxDisabled">
              <input type="checkbox" :disabled="true" />
            </span>
            <span v-else>
              <input
                type="checkbox"
                id="props.row.id"
                :value="props.row.dateCreated"
                v-model="checkedData"
              />
            </span>
          </span> -->
          <!-- <span v-if="props.column.field == 'checkbox'">
            <input
              type="checkbox"
              id="props.row.id"
              :value="props.row.id"
              v-model="checkedData"
              style="margin: 10px"
              @change="selectionChanged"
            />
          </span> -->
          <span v-if="props.column.field == 'after'">
            <button
              class="btn btn-primary"
              style="width: 145px"
              data-bs-toggle="modal"
              data-bs-target="#downloadScuModal"
            >
              Download Package
            </button>
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
  <request-scu-modal />
  <download-scu-modal 
  :selected-id="typesenseStore.currentContent?.uuid"
  />
  
  
</template>

<script setup lang="ts">
import RequestScuModal from "@/components/Modal/RequestScuModal.vue";
import DownloadScuModal from "@/components/Modal/DownloadScuModal.vue";
import PaginationRecords from "@/components/Pagination/PaginationRecords.vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { useDownloadStore } from "@/stores/download";
import { useTypesenseStore } from "@/stores/typesense";
import { useAsyncState } from "@vueuse/core";
import moment from "moment";
import { ref, watch } from "vue";

const table = ref();
const authStore = useAuthenticationStore();
const typesenseStore = useTypesenseStore();
const downloadStore = useDownloadStore();
const TypesenseKey = ref();
const type = ref("secure-zone-downloads");
const isLoading = ref(false);

watch(
  () => downloadStore.loading,
  (updateLoading) => (isLoading.value = updateLoading)
);

watch(
  () => typesenseStore.loading,
  (updateLoading) => (isLoading.value = updateLoading)
);

const paginationOptions = ref({
  enabled: true,
  mode: "pages",
  position: "bottom",
  perPage: 20,
  perPageDropdown: [10, 20, 30],
  dropdownAllowAll: false,
});

const serverParams = ref({
  filter_by:
    " type:=SCU && requester:=" +
    authStore.profile_email,
  sort_by: "",
  q: "*",
  query_by: "", // can include more fields.
  page: 1,
  per_page: paginationOptions.value.perPageDropdown[1],
});

const updateParams = (newProps: any) => {
  serverParams.value = Object.assign({}, serverParams.value, newProps);
};

const onPageChange = (params) => {
  updateParams({ page: params.currentPage });
  execute();
};

const onPerPageChange = (params) => {
  updateParams({ per_page: params.currentPerPage, page: 1 });
  execute();
};

const onSortChange = (params) => {
  if (params[0].type === "none") {
    updateParams({
      sort_by: "",
    });
  } else {
    updateParams({
      sort_by: params[0].field + ":" + params[0].type,
    });
  }
  execute();
};

const { execute, error } = useAsyncState(() => {
  return typesenseStore.fetchTypesense(type.value, serverParams.value);
}, null);

// const dateCreated = (rowObj) => {
//   return moment.unix(rowObj.requested_at).format("DD MMMM yyyy HH:mm:ss");
// };

const dateCreated = (value) => {
  return moment.unix(value).format("DD MMM yyyy HH:mm:ss");
};

const columns = [
  {
    label: "Date Created",
    field: "requested_at",
    formatFn: dateCreated,
  },
  {
    label: "Type of Content Available",
    field: "type",
    formatFn: function (value) {
      if (value == "SCU") return "System Configure Update";
    },
  },
  {
    label: "Request UUID",
    field: "uuid",
    sortable: false,
  },
  {
    label: "Status",
    field: "status",
    sortable: false,
  },
  {
    label: "",
    field: "after",
    width: "160px",
    sortable: false,
  },
];
</script>

<style scoped>
.container-fluid {
  padding: 16px;
}
.btn-download {
  position: relative;
  float: right;
  width: 240px;
}
.vue-table {
  padding: 10px;
}
</style>
